export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M10.413 3.97c.644-1.29 2.484-1.291 3.13-.002l8.263 14.497A1.75 1.75 0 0 1 20.242 21H3.759a1.75 1.75 0 0 1-1.566-2.532l8.22-14.497ZM11.977 16a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm0-8.25c-.69 0-1.25.56-1.25 1.25v4.75a1.25 1.25 0 0 0 2.5 0V9c0-.69-.56-1.25-1.25-1.25Z"/>
</svg>
`;
